import { PageHeader } from '@frontendmentorio/design-system-v2';

import Layout from 'features/shared/Layout';
import ChallengesShow from 'features/challenges/Show';

export default function Show({ articles, challenge }) {
  return (
    <Layout
      description={challenge.description}
      image={challenge.gallery[0] ? challenge.gallery[0].preview : ''}
      title={`Frontend Mentor | ${challenge.title} coding challenge`}
      url={`https://www.frontendmentor.io/challenges/${challenge.slug}`}
    >
      <PageHeader heading="Challenge" />
      <ChallengesShow articles={articles} challenge={challenge} />
    </Layout>
  );
}

export async function getStaticPaths() {
  const paths = [];
  const pages = [1, 2, 3];

  for (const page of pages) {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_REST_API_URL}/v3/challenges?page=${page}&size=40`
    );

    const body = await res.json();
    paths.push(
      ...body.data.map((challenge) => ({ params: { slug: challenge.slug } }))
    );
  }

  return { paths, fallback: 'blocking' };
}

export async function getStaticProps({ params }) {
  const ARTICLES = [
    'figma-for-developers-how-to-work-with-a-design-file-m6CZKZ1rC1',
    'git-and-github-essentials-a-beginners-guide-T4i1dKqfmH',
    'the-benefits-of-writing-a-good-challenge-readme-3EIwMaYVgz',
  ];

  const challenge = await fetch(
    `${process.env.NEXT_PUBLIC_REST_API_URL}/v3/challenges/${params.slug}`
  ).then((res) => res.json());

  if (!challenge.data) return { notFound: true };

  const articles = await fetch(
    `${process.env.NEXT_PUBLIC_REST_API_URL}/v3/articles?filter=slug|${ARTICLES}`
  ).then((res) => res.json());

  return {
    props: { articles: articles.data, challenge: challenge.data },
    revalidate: 60 * 60 * 24,
  };
}
